import {Routes, Route} from "react-router-dom";
import React, {useState, useEffect} from "react";
import {NotFound} from "./not-found";
import {NotAuthorized} from "./not-authorized";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import {DashboardLayout} from "../components/dashboard-layout";
import {Home} from "./home";
import CssBaseline from "@mui/material/CssBaseline/CssBaseline";
import SessionTimeout from "../components/session-timeout";
import {CourtApprovals} from "./court-approvals";
import {Users} from "./users";
import {useDispatch, useSelector} from "react-redux";
import {getUsers} from "../ducks/user";
import {Loader} from "../components/loader";
import {CourtCorrections} from "./court-corrections";
import {CourtCorrectionsDetail} from "./court-corrections-detail";
import {UserDetail} from "./user-detail";
import {AppStore} from "./app-store";

export const Dashboard = () => {

    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    const users = useSelector((state) => state.user.users);

    useEffect(() => {
        async function fetchData() {
            if (users.length == 0) {
                setIsLoading(true);

                dispatch(getUsers());
            }

            setIsLoading(false);
        }

        fetchData();
    }, []);

    if (isLoading) {
        return (<Loader/>);
    }

    return (
        <>
            {/*<SessionTimeout/>*/}
            <CssBaseline/>
            <DashboardLayout>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        py: 8
                    }}
                >
                    <Container maxWidth={false}>
                        <div>
                            <Routes>
                                <Route
                                    path="/"
                                    element={<Home/>}/>
                                <Route
                                    path="/app-store"
                                    element={<AppStore/>}/>
                                <Route
                                    path="/users"
                                    element={<Users/>}
                                />
                                <Route
                                    path="/user-detail/:id"
                                    element={<UserDetail/>}
                                />
                                <Route
                                    path="/court-approvals"
                                    element={<CourtApprovals/>}
                                />
                                <Route
                                    path="/court-corrections"
                                    element={<CourtCorrections/>}
                                />
                                <Route
                                    path="/court-corrections-detail/:id"
                                    element={<CourtCorrectionsDetail/>}
                                />
                                <Route
                                    path="/app-store"
                                    element={<AppStore/>}
                                />
                                <Route
                                    path="/not-authorized"
                                    element={<NotAuthorized/>}
                                />
                                <Route path="*" element={<NotFound/>}/>
                            </Routes>
                        </div>
                    </Container>
                </Box>
            </DashboardLayout>
        </>
    );
}
